<template>
  <div class="og-spotlight">
    <!-- 双卡片区：类似 gbmodshub「新版本 / 旧版」的信息节奏，我们做成「最新 APK」+「对比选型」 -->
    <section class="og-spotlight__releases" aria-label="OG WhatsApp download and comparison cards">
      <div class="og-spotlight__inner">
        <div class="og-release-cards">
          <article class="og-release-card og-release-card--lead">
            <span class="og-release-card__eyebrow">OG WhatsApp APK</span>
            <p class="og-release-card__title">Get the Latest Version</p>
            <p class="og-release-card__text">
              File name, size, and install steps in one place—verify checksums before you sideload.
            </p>
            <router-link class="og-release-card__link" :to="{ name: 'en-download' }">
              Download OG WhatsApp APK
              <span class="og-release-card__arrow" aria-hidden="true">→</span>
            </router-link>
          </article>
          <article class="og-release-card og-release-card--alt">
            <span class="og-release-card__eyebrow">Not sure which mod?</span>
            <p class="og-release-card__title">OG WhatsApp vs GB WhatsApp</p>
            <p class="og-release-card__text">
              Side-by-side differences, trade-offs, and safety notes—without hype.
            </p>
            <router-link class="og-release-card__link og-release-card__link--outline" :to="{ name: 'en-compare-og-gb' }">
              Open comparison
              <span class="og-release-card__arrow" aria-hidden="true">→</span>
            </router-link>
          </article>
        </div>
      </div>
    </section>

    <!-- 深色功能带：标签式卖点，区别于正文长段落 -->
    <section class="og-spotlight__features-band" aria-labelledby="og-spot-features-title">
      <div class="og-spotlight__features-band-bg" aria-hidden="true" />
      <div class="og-spotlight__inner og-spotlight__inner--features">
        <div class="og-spotlight__features-head">
          <h2 id="og-spot-features-title" class="og-spotlight__features-title">Top features people enable first</h2>
          <p class="og-spotlight__features-sub">
            Practical extras on unofficial builds—availability depends on your exact APK fork.
          </p>
        </div>
        <ul class="og-feature-pills">
          <li v-for="(item, i) in featurePills" :key="i" class="og-feature-pill">
            <span class="og-feature-pill__icon" aria-hidden="true">{{ item.icon }}</span>
            <span class="og-feature-pill__label">{{ item.label }}</span>
          </li>
        </ul>
      </div>
    </section>

    <!-- 简介条：App info 快照 + 导向长文 -->
    <section class="og-spotlight__intro" aria-labelledby="og-spot-intro-title">
      <div class="og-spotlight__inner og-spotlight__inner--intro">
        <div class="og-intro-split">
          <div class="og-intro-copy">
            <h2 id="og-spot-intro-title" class="og-intro-title">Introducing OG WhatsApp</h2>
            <p class="og-intro-text">
              A third-party WhatsApp-style client for Android with deeper privacy toggles, themes, and media helpers.
              It is <strong>not</strong> published by WhatsApp LLC—read risks before you install.
            </p>
            <router-link class="og-intro-more" :to="{ name: 'en-download' }">
              View file info &amp; steps
            </router-link>
          </div>
          <div class="og-intro-table-wrap">
            <table class="og-intro-table">
              <caption class="og-visually-hidden">OG WhatsApp snapshot</caption>
              <tbody>
                <tr>
                  <th scope="row">App</th>
                  <td>OG WhatsApp</td>
                </tr>
                <tr>
                  <th scope="row">Platform</th>
                  <td>Android 5.0+</td>
                </tr>
                <tr>
                  <th scope="row">Package</th>
                  <td>APK (sideload)</td>
                </tr>
                <tr>
                  <th scope="row">Pricing</th>
                  <td>Free</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'OgHomeSpotlight',
  data() {
    return {
      featurePills: [
        { icon: '🔒', label: 'Privacy layers' },
        { icon: '📱', label: 'Dual WhatsApp' },
        { icon: '🎨', label: 'Themes & UI' },
        { icon: '📥', label: 'Status tools' },
        { icon: '🛡️', label: 'Chat lock' },
        { icon: '🌙', label: 'DND mode' },
        { icon: '📎', label: 'Larger media' },
        { icon: '🔄', label: 'Backup friendly' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.og-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.og-spotlight {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.og-spotlight__inner {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding-left: max(16px, env(safe-area-inset-left));
  padding-right: max(16px, env(safe-area-inset-right));
  box-sizing: border-box;
}

/* —— 双卡片 —— */
.og-spotlight__releases {
  padding: 2rem 0 1.5rem;
  background: #ffffff;
}

.og-release-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

@media (min-width: 768px) {
  .og-release-cards {
    grid-template-columns: 1.05fr 1fr;
    gap: 1.25rem;
  }
}

.og-release-card {
  border-radius: 4px;
  padding: 1.35rem 1.5rem;
  border: 1px solid #e5e5e5;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.og-release-card--lead {
  border-left: 4px solid #34d399;
  background: #ffffff;
}

.og-release-card__eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #204f46;
}

.og-release-card__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  color: #204f46;
  line-height: 1.25;
}

.og-release-card__text {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
  color: #333333;
  flex: 1;
}

.og-release-card__link {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-weight: 700;
  font-size: 0.95rem;
  color: #ffffff !important;
  text-decoration: none !important;
  padding: 0.65rem 1.15rem;
  border-radius: 4px;
  background: #204f46;
  border: none;
  margin-top: 0.25rem;
  box-shadow: none;
  transition: background 0.15s ease, transform 0.15s ease;
}

.og-release-card__link:hover {
  transform: translateY(-1px);
  background: #34d399 !important;
  color: #ffffff !important;
}

.og-release-card__link--outline {
  background: #ffffff !important;
  color: #204f46 !important;
  border: 1px solid #e5e5e5;
  box-shadow: none;
}

.og-release-card__link--outline:hover {
  border-color: #34d399;
  background: #ffffff !important;
  color: #204f46 !important;
}

.og-release-card__arrow {
  transition: transform 0.15s ease;
}

.og-release-card__link:hover .og-release-card__arrow {
  transform: translateX(3px);
}

/* —— 深色功能带 —— */
.og-spotlight__features-band {
  position: relative;
  padding: 2.25rem 0 2.5rem;
  overflow: hidden;
}

.og-spotlight__features-band-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    145deg,
    #163d36 0%,
    #204f46 50%,
    #18332e 100%
  );
  z-index: 0;
}

.og-spotlight__features-band-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
      circle at 15% 20%,
      rgba(52, 211, 153, 0.2) 0%,
      transparent 45%
    ),
    radial-gradient(
      circle at 85% 80%,
      rgba(255, 255, 255, 0.06) 0%,
      transparent 40%
    );
  pointer-events: none;
}

.og-spotlight__inner--features {
  position: relative;
  z-index: 1;
}

.og-spotlight__features-head {
  text-align: center;
  margin-bottom: 1.5rem;
  max-width: 36rem;
  margin-left: auto;
  margin-right: auto;
}

.og-spotlight__features-title {
  margin: 0 0 0.5rem;
  font-size: clamp(1.25rem, 3vw, 1.5rem);
  font-weight: 800;
  color: #f1f5f9;
  letter-spacing: -0.02em;
}

.og-spotlight__features-sub {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: rgba(241, 245, 249, 0.82);
}

.og-feature-pills {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.og-feature-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.09);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #f1f5f9;
  font-size: 0.875rem;
  font-weight: 600;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.og-feature-pill:hover {
  background: rgba(52, 211, 153, 0.18);
  border-color: rgba(52, 211, 153, 0.45);
}

.og-feature-pill__icon {
  font-size: 1rem;
  line-height: 1;
}

/* —— 简介 + 表 —— */
.og-spotlight__intro {
  padding: 2rem 0 1rem;
  background: #fff;
}

.og-intro-split {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  align-items: start;
}

@media (min-width: 768px) {
  .og-intro-split {
    grid-template-columns: 1.15fr minmax(260px, 340px);
    gap: 2rem;
    align-items: center;
  }
}

.og-intro-title {
  margin: 0 0 0.75rem;
  font-size: 1.45rem;
  font-weight: 800;
  color: #333333;
}

.og-intro-text {
  margin: 0 0 1rem;
  font-size: 1rem;
  line-height: 1.65;
  color: #333333;
}

.og-intro-more {
  font-weight: 700;
  color: #204f46 !important;
  text-decoration: none !important;
  border-bottom: 1px solid transparent;
  padding-bottom: 2px;
}

.og-intro-more:hover {
  color: #34d399 !important;
  border-bottom-color: #34d399;
  text-decoration: none !important;
}

.og-intro-table-wrap {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  box-shadow: 0 6px 24px rgba(15, 23, 42, 0.06);
}

.og-intro-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;
}

.og-intro-table th,
.og-intro-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.og-intro-table tr:last-child th,
.og-intro-table tr:last-child td {
  border-bottom: none;
}

.og-intro-table th {
  width: 38%;
  background: #eff8f5;
  color: #204f46;
  font-weight: 700;
}

.og-intro-table td {
  background: #fff;
  color: #333333;
  font-weight: 600;
}
</style>
